import { CheckCircle, Warning } from '@phosphor-icons/react';
import { Loading } from '@whistler-ui/k2/components/Loading';
import React from 'react';

import { CREATED, FAILED, RUNNING, SUCCESS, VOID } from '../constants/';

/**
 * Function to get value from an object using a path as string or array
 * @example
 * // returns 2
 * getValueFromPath({a: {b: 2}}, "a.b")
 *
 * @example
 * // returns 3
 * const response = {firstLevel: {secondLevel: 3}}
 * getValueFromPath(response, "firstLevel.secondLevel")
 *
 * @param {Object} object
 * @param {string | string[]} path
 * @param {string=} separator [separator=.] - default separator
 * @returns *
 */
export const getValueFromPath = (object, path, separator = '.') => {
  const properties = Array.isArray(path) ? path : path.split(separator);
  return properties.reduce((prev, current) => prev?.[current], object);
};

/**
 * Function to parse value of nested properties in an object using an array of string as routes, and a parser function
 * if the route do not exist, the value will be ignored
 * @example
 * // returns {a: {b: 2}}
 * parseValueFromPath({a: {b: "2"}}, ["a.b"], (value) => parseInt(value))
 * @example
 * // returns {firstLevel: {secondLevel: 3}}
 * const response = {firstLevel: {secondLevel: "3"}}
 * parseValueFromPath(response, ["firstLevel.thirdLevel"], (value) => parseInt(value))
 * @param {Object} object
 * @param {string[]} paths
 * @param {Function} parser
 * @param {string=} separator [separator=.] - default separator
 * @returns {Object}
 */

export const oAuthValues = [
  'oauth_configuration.authentication.scope',
  'oauth_configuration.authentication.other',
  'oauth_configuration.token_authorization.other',
];
export const parseValueFromPath = (object, paths, parser, separator = '.') => {
  const parsedObject = { ...object };
  paths.forEach(path => {
    const properties = Array.isArray(path) ? path : path.split(separator);
    const value = getValueFromPath(parsedObject, properties);

    if (value === undefined) {
      return;
    }

    const parsedValue = parser(value);
    properties.reduce((prev, current, index) => {
      if (index === properties.length - 1) {
        prev[current] = parsedValue;
      }
      return prev[current];
    }, parsedObject);
  });
  return parsedObject;
};

export const removeNull = obj => {
  if (!obj) return obj;
  return Object.keys(obj)
    .filter(k => obj[k] !== null && obj[k] !== undefined)
    .reduce((a, k) => ({ ...a, [k]: obj[k] }), {});
};

export const getTabIconByStatus = (status, colors) => {
  switch (status) {
    case RUNNING:
      return <Loading size={24} variant="right" />;
    case FAILED:
      return <Warning size={24} color={colors.error} />;
    case SUCCESS:
      return <CheckCircle size={24} color={colors.success} />;
    case VOID:
      return null;
    default:
      return null;
  }
};

export const getDeviceAndTitleFromTestCase = fullTitle => {
  const regex = /(?:Android|Apple)$/gm;
  const [deviceType] = fullTitle.match(regex) || [];
  const title = fullTitle.replace(regex, '').trim();

  return [deviceType, title];
};
